export const FETCH_CASHBOOK_ENTRIES_SUCCESS = "FETCH_CASHBOOK_ENTRIES_SUCCESS";
